import React from 'react'
import { Navigate } from 'react-router-dom'

import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'
import routePath from 'router/routePath'

type QuestionGateProps = {
  redirectTo?: string
  children: React.ReactElement
}

export const QuestionGate: React.FC<QuestionGateProps> = ({
  children,
  redirectTo = routePath.notFound404,
}) => {
  const { contractTerminationOnly, defectNotice } = useModuleConfig()
  const enabled =
    !contractTerminationOnly &&
    defectNotice.enabled === true &&
    !defectNotice.customDefectNoticeLinkUrl &&
    defectNotice.question === true

  return enabled ? children : <Navigate to={redirectTo} replace />
}
